import { useRouteMatch } from "react-router";
import Url from "./Url";

const arrayNotRegionUrl = [
    "orders",
    "providers",
    "operatory",
    "news",
    "reviews",
    "compare",
    "actions",
    "rates",
    "business",
    "rating",
    "ratesMobile",
    "address",
    "feedback",
    "exclusive",
    "about",
    "sim-karty",
    "ratesmobile",
    "operatory",
    "nomera",
    "quiz",
    "contact-feedback",
    "operator",
];

export const useWithDefaultParams = region => {
    let params = Url.getDefaultParams();
    const routerMatch = useRouteMatch();

    const match = JSON.parse(JSON.stringify(routerMatch));

    let regionUrl = match.params.regionUrl;
    match.params.regionUrlComing = regionUrl;

    if (arrayNotRegionUrl.find(r => r == regionUrl)) {
        regionUrl = "";
    }

    if (!!region && !arrayNotRegionUrl.find(r => r == region)) {
        regionUrl = region;
    }

    if (!regionUrl && params.hasOwnProperty("regionUrl")) {
        regionUrl = params.regionUrl;
    }

    match.params.regionUrl = regionUrl;

    return match;
};
